import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UserSignupPayload {
  email: string;
  userName: string;
  displayName: string;
  password: string;
}

export interface UserLoginPayload {
  email: string;
  password: string;
  clientId?: string;
}

export interface UserForgotPayload {
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}`;

  signupUser(payload: UserSignupPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/signup`, payload);
  }

  signupMerchant(payload: UserSignupPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/signup/merchant`, payload);
  }

  signinUser(payload: UserLoginPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/login`, payload);
  }

  forgotPassword(payload: UserForgotPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/forgot-password`, payload);
  }

  resetPassword(data: { token: string; password: string }) {
    return this.http.post(`${this.baseUrl}/auth/reset-password`, data);
  }

  googleLogin(idToken: string, clientId?: string) {
    return this.http.post(`${this.baseUrl}/auth/google`, { idToken, clientId });
  }

  facebookLogin(accessToken: string, clientId?: string) {
    return this.http.post(`${this.baseUrl}/auth/facebook`, { accessToken, clientId });
  }

  verifyEmail(token: string) {
    return this.http.get(
      `${this.baseUrl}/auth/verify-email?token=${token}`
    );
  }

  /** Sends a fresh verification link to an unverified account's email. */
  resendVerification(email: string) {
    return this.http.post(`${this.baseUrl}/auth/resend-verification`, { email });
  }

  refreshToken(refreshToken: string, clientId?: string) {
    return this.http.post(`${this.baseUrl}/auth/refresh`, { refreshToken, clientId });
  }

  /** Swap a one-time admin "Quick Login" token for a normal session. */
  quickLogin(token: string, clientId?: string) {
    return this.http.post(`${this.baseUrl}/auth/quick-login`, { token, clientId });
  }

  logout(clientId?: string) {
    return this.http.post(`${this.baseUrl}/auth/logout`, { clientId });
  }


}
